import styled from 'styled-components'

export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-top: 1.5rem;
  width: 100%;
`

export const PaginationSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const CustomButton = styled.button`
  padding: 0.3rem 0.8rem;
  border-radius: 6px;
  font-family: Work Sans;
  font-size: 14px;
  font-weight: bold;
  color: white;
  width: 7rem;
  background-color: ${({ disabled, theme }) => (disabled ? '#bbbbbb' : theme.colors.blue)};
`

export const PageLabel = styled.span`
  font-family: Work Sans;
  font-size: 14px;
  font-weight: 600;
`

export const SectionLabel = styled.span`
  font-family: Work Sans;
  font-size: 14px;
  white-space: nowrap;
`

export const GoToInput = styled.input`
  width: 5rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-family: Work Sans;
  font-size: 14px;
  text-align: center;
  outline: none;
  &:focus {
    border-color: #1976d2;
  }
`
